module.exports = __webpack_public_path__ + "media/images/icons/icon_trash_red-4fac67569bf22ac48ee6a95741a89ed2.svg";